// ─── Datos de contacto y enlaces ─────────────────────────────────────────────
export const CONTACT_PHONE = "+34 614 046 352";
export const CONTACT_EMAIL = "automatiza@ancoraautomations.es";
export const WHATSAPP_LINK = "https://wa.me/34614046352";
export const CALENDLY_LINK = "https://calendly.com/ancora-automations/consultoria";

// ─── Datos de la empresa ────────────────────────────────────────────────────
export const COMPANY_NAME = "Ancora Automations";
export const COMPANY_TAGLINE = "Automatización inteligente con WhatsApp e IA";
export const COMPANY_DESCRIPTION =
  "Construimos chatbots de WhatsApp a medida para restaurantes, clínicas y comercios en Madrid. Reservas 24/7, recordatorios automáticos, marketing con IA.";

// ─── Logos ───────────────────────────────────────────────────────────────────
export const LOGO_LIGHT = "/logo-header.png";
export const LOGO_DARK = "/logo-footer.png";

// ─── Nav sections ────────────────────────────────────────────────────────────
export const NAV_SECTIONS = [
  { label: "Servicios", href: "#que-hacemos" },
  { label: "Sectores", href: "#hosteleria" },
  { label: "Precios", href: "#pricing" },
  { label: "Quiénes somos", href: "#quienes-somos" },
  { label: "Marketing IA", href: "#marketing-ia" },
  { label: "Blog", href: "/blog" },
];

// ─── Hero stats (4) ──────────────────────────────────────────────────────────
export const HERO_STATS = [
  { icon: "⚡", value: "5 días", label: "SETUP GRATIS" },
  { icon: "🔄", value: "24/7", label: "DISPONIBILIDAD GARANTIZADA" },
  { icon: "🛡", value: "30 días", label: "GARANTÍA DE SATISFACCIÓN" },
  { icon: "🤖", value: "90%", label: "CONSULTAS RESUELTAS SIN INTERVENCIÓN" },
];

// ─── Features (4 cards) ──────────────────────────────────────────────────────
export const FEATURES = [
  {
    title: "Atendemos a tus clientes 24/7",
    description:
      "Asistente inteligente en WhatsApp e Instagram que responde dudas, toma pedidos y cualifica leads mientras duermes.",
    tags: ["Respuesta en < 1s", "Multi-idioma"],
  },
  {
    title: "Marketing sin intervención manual",
    description:
      "Posts diarios, videos automáticos y campañas de WhatsApp con un 90% de apertura.",
    tags: ["7", "Posts semanales", "Videos con IA"],
  },
  {
    title: "Reservas automáticas",
    description:
      "Sincronización con tu calendario y recordatorios que reducen no-shows un 70%.",
    tags: [],
  },
  {
    title: "Panel de control",
    description:
      "Métricas en tiempo real, CRM de clientes y gestión de reseñas desde un solo lugar.",
    tags: [],
  },
];

// ─── Sectores (3) ────────────────────────────────────────────────────────────
export const SECTORS = [
  {
    id: "hosteleria",
    label: "Hostelería",
    tagline: "Automatiza las tareas repetitivas e incrementa tus ventas",
    solutions: [
      {
        title: "Menús Automáticos por WhatsApp",
        description:
          "Envía el menu del dia a todos tus clientes automáticamente. Graba un audio o envía una foto, y el sistema lo transcribe, formatea y distribuye a tu lista de contactos.",
        badge: "Ahorra hasta 2h diarias",
      },
      {
        title: "Reservas por WhatsApp 24/7",
        description:
          "Sistema inteligente de gestión de reservas que acepta peticiones por texto y voz. Confirma disponibilidad automáticamente, gestiona cambios y envía recordatorios.",
        badge: "+30% de reservas gestionadas",
      },
      {
        title: "Gestión de Reseñas y Reputación",
        description:
          "Respuestas automáticas a reseñas de Google con el tono de tu negocio. Solicita reseñas post-visita por WhatsApp. Cuida tu reputación sin esfuerzo.",
        badge: "Reputación gestionada 24/7",
      },
    ],
    wowList: [
      "Envía el menu del dia a 200 clientes con solo una foto de la pizarra",
      "Recibe reservas por WhatsApp a las 3AM sin perder ninguna",
      "Confirma reservas automáticamente y reduce no-shows un 70%",
      "Responde a preguntas aunque estés en cocina",
    ],
  },
  {
    id: "salud",
    label: "Salud y Belleza",
    tagline: "Maximiza tu agenda, minimiza los no-shows y fideliza clientes automáticamente",
    solutions: [
      {
        title: "Gestión de Citas por WhatsApp",
        description:
          "Sistema inteligente que gestiona citas 24/7. Tus clientes reservan cuando lo necesitan. El sistema verifica disponibilidad, confirma la cita y la registra automáticamente.",
        badge: "Disponible 24/7",
      },
      {
        title: "Recordatorios y Reducción de No-Shows",
        description:
          "Envía recordatorios automáticos 48h y 24h antes de cada cita. Si detecta cancelación, libera el hueco y ofrece disponibilidad a lista de espera.",
        badge: "-70% de no-shows",
      },
      {
        title: "Fidelización y Seguimiento Inteligente",
        description:
          "Sistema de seguimiento personalizado: check-in post-tratamiento, recordatorios de sesiones periódicas y avisos de próximas citas recomendadas.",
        badge: "+40% de recurrencia",
      },
    ],
    wowList: [
      "Reservas de citas 24/7 sin intervención manual",
      "Recordatorios automáticos que reducen no-shows un 70%",
      "Seguimiento post-tratamiento automatizado",
      "Consentimientos digitales GDPR integrados",
    ],
  },
  {
    id: "comercio",
    label: "Comercio",
    tagline: "Multiplica tu tiempo facturable eliminando tareas administrativas",
    solutions: [
      {
        title: "Atención al Cliente con IA",
        description:
          "Contesta preguntas frecuentes sobre productos, horarios o servicios 24/7. Tu defines el conocimiento base, la IA responde por WhatsApp cuando no estas disponible.",
        badge: "Disponible 24/7",
      },
      {
        title: "Seguimiento Automático de Clientes",
        description:
          "Recordatorios automáticos por WhatsApp cuando toca hacer follow-up con un cliente o renovar un servicio. El sistema contacta en el momento adecuado.",
        badge: "0% de clientes olvidados",
      },
      {
        title: "Notificaciones de Cobro y Facturas",
        description:
          "Recordatorios automáticos a clientes con facturas pendientes por WhatsApp o email. Configura cuando y como avisar, el sistema ejecuta puntualmente.",
        badge: "Cobros sin perseguir",
      },
    ],
    wowList: [
      "Atención 24/7 sin contratar más personal",
      "Follow-up automático con cada cliente",
      "Cobros puntuales sin llamadas de reclamación",
      "CRM completo con historial de interacciones",
    ],
  },
];

// ─── Marketing features (4) ──────────────────────────────────────────────────
export const MARKETING_FEATURES = [
  {
    title: "Contenido social",
    description:
      "Posts diarios en Instagram, Facebook y Google Business. Copy adaptado al tono de tu negocio.",
    highlight: "Hasta 7 posts/semana",
  },
  {
    title: "Videos con IA",
    description:
      "Reels y Stories profesionales con voz natural, imágenes de tu negocio y texto animado.",
    highlight: "Hasta 12 videos/mes",
  },
  {
    title: "Reseñas Google",
    description:
      "Monitorización automática, respuestas personalizadas con IA y solicitud post-visita.",
    highlight: "Respuesta inmediata 24/7",
  },
  {
    title: "Campañas WhatsApp",
    description:
      "Campañas segmentadas con un 90% de apertura. Promos, menú del día y fidelización.",
    highlight: "90% tasa de apertura",
  },
];

// ─── Comparativa rows ────────────────────────────────────────────────────────
export const COMPARISON_ROWS = [
  { feature: "Coste mensual", self: "0 (tu tiempo)", cm: "800-1.500€", agency: "1.500-3.000€", ancora: "Desde 9,99€", ancoraGood: true },
  { feature: "Posts/semana", self: "Cuando puedes", cm: "3-5", agency: "5-7", ancora: "Hasta 7 (diario)", ancoraGood: true },
  { feature: "Chatbot 24/7", self: "No", cm: "No", agency: "No", ancora: "Sí", ancoraGood: true },
  { feature: "Reservas automáticas", self: "No", cm: "No", agency: "No", ancora: "Sí", ancoraGood: true },
  { feature: "Videos con IA", self: "No", cm: "No", agency: "Aparte (~500€)", ancora: "Incluido", ancoraGood: true },
  { feature: "Respuesta a reseñas", self: "Manual", cm: "Lenta", agency: "Lenta", ancora: "Inmediata", ancoraGood: true },
  { feature: "Disponibilidad", self: "Tu horario", cm: "L-V 9-18", agency: "L-V 9-18", ancora: "24/7/365", ancoraGood: true },
  { feature: "Escalable", self: "No", cm: "Difícil", agency: "Caro", ancora: "Automático", ancoraGood: true },
];

// ─── Planes de precios (4) ───────────────────────────────────────────────────
export const PLANS = [
  {
    id: "starter",
    name: "STARTER",
    price: 9.99,
    priceLabel: "9,99",
    originalPrice: "29,99",
    badge: "Precio de lanzamiento",
    description: "",
    features: [
      "Asistente WhatsApp con IA 24/7",
      "Reservas y citas automáticas",
      "Recordatorios (reduce no-shows 70%)",
      "Sin permanencias",
    ],
    highlight: false,
  },
  {
    id: "business",
    name: "BUSINESS",
    price: 79.99,
    priceLabel: "79,99",
    originalPrice: null,
    badge: "Más popular",
    description: "",
    features: [
      "Todo lo del plan Starter",
      "Respuestas a preguntas frecuentes",
      "Seguimiento post-visita automático",
      "Google Business Profile optimizado",
      "Instagram: publicación automática ilimitada",
      "Instagram DMs integrado",
      "Campañas WhatsApp ilimitadas (menú del día, promos, avisos)",
      "Email marketing automatizado",
      "Gestión de reseñas Google",
      "CRM de clientes avanzado",
      "Informe + recomendaciones personalizadas",
    ],
    highlight: true,
  },
  {
    id: "growth",
    name: "GROWTH",
    price: 199.99,
    priceLabel: "199,99",
    originalPrice: null,
    badge: null,
    description: "",
    features: [
      "Todo lo del plan Business",
      "Agente de voz IA (atiende llamadas)",
      "Llamadas salientes automatizadas",
      "Vídeos IA para redes (Reels, TikTok)",
      "Consentimientos GDPR automáticos",
      "Blog SEO (2 artículos/mes)",
      "Soporte prioritario",
      "Informe + videollamada mensual 30min",
    ],
    highlight: false,
  },
  {
    id: "a-medida",
    name: "A MEDIDA",
    price: 9.99,
    priceLabel: "9,99",
    originalPrice: null,
    badge: null,
    description: "",
    features: [
      "Integración con tu software de reservas o gestión",
      "Automatización de procesos específicos de tu negocio",
      "Agente adaptado a tu operativa real",
      "Mismo setup gratis, misma garantía 30 días",
    ],
    highlight: false,
    isCustom: true,
  },
];

// ─── FAQ para sección de contacto (5 preguntas con tildes) ───────────────────
export const FAQS = [
  {
    question: "¿Necesito conocimientos técnicos para usarlo?",
    answer:
      "No, es lo opuesto. Nosotros nos encargamos de toda la configuración técnica, integración y puesta en marcha. Tú solo nos dices qué quieres que haga la IA y nosotros lo montamos.",
  },
  {
    question: "¿Cuánto tarda en estar funcionando?",
    answer:
      "Dependiendo del plan y la complejidad, tu asistente de IA puede estar respondiendo a clientes y gestionando tu negocio en un plazo de 7 a 14 días.",
  },
  {
    question: "¿Qué pasa si la IA no sabe responder algo?",
    answer:
      "La IA está entrenada con la información de tu negocio. Si se encuentra con una pregunta que no sabe responder, puede transferir la conversación a un humano (a tu equipo) de forma transparente.",
  },
  {
    question: "¿Es seguro para los datos de mis clientes?",
    answer:
      "Sí. Cumplimos RGPD, encriptación de extremo a extremo, y los datos de tus clientes nunca se usan para entrenar modelos públicos.",
  },
  {
    question: "¿Puedo cancelar en cualquier momento?",
    answer:
      "Sí, nuestros planes no tienen permanencia. Puedes cancelar tu suscripción en cualquier momento sin penalizaciones.",
  },
];

// ─── FAQ para sección de pricing (7 preguntas sin tildes) ────────────────────
export const FAQ_PRICING = [
  {
    question: "Qué incluye cada plan?",
    answer:
      "El Starter es lo esencial: asistente WhatsApp con IA, reservas automáticas y recordatorios. El Business añade FAQ, seguimiento post-visita, Google Business, Instagram, campañas y CRM. El Growth incluye agente de voz IA, vídeos y blog SEO.",
  },
  {
    question: "Necesito saber de tecnología?",
    answer:
      "No. Nosotros configuramos todo en 5 días. Tu solo usas WhatsApp como siempre.",
  },
  {
    question: "El setup es gratis de verdad?",
    answer:
      "Si. En todos los planes el setup es completamente gratis. Configuramos todo sin coste: conectamos tu WhatsApp, entrenamos el asistente con los datos de tu negocio y lo dejamos funcionando en 5 días.",
  },
  {
    question: "Puedo cambiar de plan?",
    answer:
      "Si, puedes subir o bajar de plan en cualquier momento sin penalizaciones.",
  },
  {
    question: "Qué pasa si cancelo?",
    answer:
      "Dejas de pagar y el servicio se desactiva. Sin penalizaciones, sin preguntas. Si vuelves en menos de 3 meses, reactivamos sin coste adicional.",
  },
  {
    question: "¿Hay costes ocultos?",
    answer:
      "No. Todo está incluido en tu plan mensual. Los mensajes de WhatsApp, el hosting y el soporte van incluidos.",
  },
  {
    question: "Y si mi negocio necesita algo que no está en los planes?",
    answer:
      "No pasa nada. Hacemos integraciones con tu software de reservas o gestión, automatizamos procesos concretos y adaptamos el asistente a tu operativa. El precio base es el mismo que el de cualquier plan. Solo te cobramos más si el desarrollo lo requiere, y te lo decimos antes de empezar.",
  },
];

// ─── Pasos de cómo funciona ─────────────────────────────────────────────────
export const HOW_IT_WORKS_STEPS = [
  {
    number: 1,
    title: "Consulta",
    description: "Llamada de 30 min para entender tu negocio",
  },
  {
    number: 2,
    title: "Diseño",
    description: "Configuramos tu plan a medida (2 días)",
  },
  {
    number: 3,
    title: "Activación",
    description: "Conectamos todo y lo probamos (3 días)",
  },
  {
    number: 4,
    title: "Despegue",
    description: "Todo funcionando",
  },
];

// ─── Quiénes somos features ──────────────────────────────────────────────────
export const QUIENES_SOMOS_FEATURES = [
  {
    title: "Implementación en 5 días",
    description: "No vendemos proyectos de meses. En una semana tu negocio tiene el sistema funcionando.",
  },
  {
    title: "Sin permanencia",
    description: "Mes a mes. Si un mes no te compensa, lo cancelas y punto. Sin penalizaciones.",
  },
  {
    title: "Solo lo que necesitas",
    description: "No empaquetamos funciones que no vas a usar. Cada negocio tiene un plan a medida.",
  },
  {
    title: "En Madrid, para Madrid",
    description: "Conocemos el mercado local. Podemos sentarnos contigo a tomar un café y enseñarte cómo funciona.",
  },
];

// ─── Casos de éxito ──────────────────────────────────────────────────────────
export const SUCCESS_STORIES = [
  {
    name: "Seven Sisters Tattoo",
    headline: "100% compliance legal sin papeleo",
    headlineHighlight: "100% compliance legal",
    headlineSuffix: "sin papeleo",
    category: "Tattoo & Body Art",
    location: "Madrid",
    metric: "100% compliance legal",
    description:
      "Raúl gestionaba su estudio en Madrid entre mensajes de WhatsApp, consentimientos en papel y citas que se perdían. Ahora tiene un sistema digital completo que cumple el <strong>Decreto 35/2005 de la Comunidad de Madrid</strong> de forma automática - sin archivadores, sin olvidos.",
    image: "/seven-sisters-exterior.jpg",
    images: ["/seven-sisters-exterior.jpg", "/seven-sisters-interior.jpg"],
    icon: "palette",
    badge: "Decreto 35/2005 ✓",
    plan: "Business",
    since: "2024",
    quote:
      "Antes tenía una carpeta llena de consentimientos en papel que nadie revisaba. Ahora el cliente firma desde su móvil, yo registro la trazabilidad del material en 2 minutos, y sé que si viene una inspección estoy cubierto.",
    quoteAuthor: "Raúl, Seven Sisters Tattoo · Madrid",
    stats: [
      { value: "100%", label: "Compliance" },
      { value: "-85%", label: "No-shows" },
      { value: "24/7", label: "Reservas" },
    ],
    features: [
      "Consentimientos digitales legales con firma electrónica",
      "Trazabilidad completa: tintas, agujas, fotos del material",
      "Recordatorios automáticos 48h, 24h y 1h antes de la cita",
      "Asistente WhatsApp + Instagram para reservas 24/7",
    ],
  },
  {
    name: "Consentirme",
    headline: "Treatwell, Booksy y WhatsApp conectados",
    headlineHighlight: "Treatwell, Booksy y WhatsApp",
    headlineSuffix: "conectados en un solo sistema",
    category: "Belleza & Bienestar",
    location: "Barajas, Madrid",
    metric: "4,8★ en Treatwell",
    description:
      "Consentirme atiende reservas de belleza y bienestar desde varios canales. Con Ancora, las citas de <strong>Treatwell y Booksy</strong> se sincronizan con el asistente de WhatsApp/Instagram, se bloquean huecos para evitar solapes y el equipo puede consultar agenda, fichajes y campañas desde el mismo sistema.",
    image: "/img/consentirme-treatwell-1.jpg",
    images: ["/img/consentirme-treatwell-1.jpg", "/img/consentirme-treatwell-2.jpg"],
    icon: "sparkles",
    badge: "Treatwell + Booksy ✓",
    plan: "Business",
    since: "2026",
    quote:
      "El objetivo era no perder reservas ni duplicar huecos entre plataformas. Ahora el sistema detecta citas, clientes y disponibilidad, y mantiene al equipo informado sin revisar todo a mano.",
    quoteAuthor: "Guzmán, dueño de Consentirme Barajas · Madrid",
    stats: [
      { value: "4,8★", label: "Treatwell" },
      { value: "99", label: "Reseñas" },
      { value: "24/7", label: "Agenda" },
    ],
    features: [
      "Sincronización de citas con Treatwell y Booksy",
      "Bloqueo automático de huecos para evitar dobles reservas",
      "Opt-in y campañas WhatsApp para clientes con consentimiento",
      "Fichajes del equipo por geolocalización y reportes para el owner",
    ],
  },
];

// ─── Meta tags ──────────────────────────────────────────────────────────────
export const META = {
  title: "Chatbot WhatsApp Madrid → Desde 9,99€/mes | Ancora",
  description:
    "Bot WhatsApp en 24h: reservas, citas y recordatorios automáticos. Desde 9,99€/mes, setup gratis, sin permanencia. Pruébalo 30 días sin riesgo.",
  keywords:
    "chatbot whatsapp, automatización whatsapp, reservas automáticas, bot madrid, ia restaurantes, ia clínicas",
  ogImage: "https://www.ancoraautomations.es/og-image.jpg",
};